import { Field } from 'formik'
import * as Yup from 'yup'
import { FormikFormControl } from '~/components/v2/formik/FormikFormControl'
import { Checkbox, Input, SimpleGrid, Text } from '~/design_system'
import { FieldSelector } from './FieldSelector'

export const PadTextValidations = {
  fields: Yup.array(
    Yup.object({
      path: Yup.string().required('Source is required').nullable(),
      field: Yup.string().required('Field is required').nullable()
    })
  ),
  value: Yup.string().required('Padding value is required').nullable(),
  length: Yup.number().integer().max(50).min(1).required('Padding length is required').nullable()
}

export const PadText = ({ calculatedField, setFieldValue }) => {
  return (
    <div>
      <FieldSelector calculatedField={calculatedField} types={['string', 'integer']} maxFields={1} />

      <SimpleGrid columns={[2, 4]} spacing={4} mt={4}>
        <FormikFormControl label="Padding Value">
          <Field name="value" type="text" as={Input} />
        </FormikFormControl>

        <FormikFormControl label="Padding Length">
          <Field name="length" type="number" as={Input} />
        </FormikFormControl>
      </SimpleGrid>

      <Checkbox
        mb={0}
        isChecked={!!calculatedField.is_right}
        name="is_right"
        paddingTop={2}
        onChange={e => setFieldValue('is_right', e.target.checked)}>
        <Text fontSize="sm" fontWeight="normal" marginBottom={0}>
          Is Right Padding
        </Text>
      </Checkbox>
    </div>
  )
}
